var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card-desc",class:[
      _vm.withoutBorder ? 'without-border' : '',
      _vm.withoutTopMargin ? 'without-top-margin' : '' ]},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }